import { useCallback, useMemo, useState } from "react";
import { favouritesStorage } from "./favouritesStorage";

/**
 * Session-level favourites (tab sessionStorage) + “show favourites only” filter.
 */
export function useFavourites() {
  const [ids, setIds] = useState(() => favouritesStorage.readIds());
  const [filterOn, setFilterOn] = useState(() =>
    favouritesStorage.readFilterOn()
  );

  const favouriteIdSet = useMemo(() => new Set(ids), [ids]);

  const isFavourite = useCallback(
    (schoolId) => favouriteIdSet.has(Number(schoolId)),
    [favouriteIdSet]
  );

  const toggleFavourite = useCallback((schoolId) => {
    const id = Number(schoolId);
    if (!Number.isFinite(id)) return;
    setIds((prev) => {
      const next = prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id];
      favouritesStorage.writeIds(next);
      return next;
    });
  }, []);

  const toggleFavouritesFilter = useCallback(() => {
    setFilterOn((prev) => {
      const next = !prev;
      favouritesStorage.writeFilterOn(next);
      return next;
    });
  }, []);

  const filterSchools = useCallback(
    (schools) => {
      if (!filterOn || !Array.isArray(schools)) return schools || [];
      return schools.filter((s) => favouriteIdSet.has(Number(s.id)));
    },
    [filterOn, favouriteIdSet]
  );

  return {
    favouriteCount: ids.length,
    filterOn,
    isFavourite,
    toggleFavourite,
    toggleFavouritesFilter,
    filterSchools,
  };
}
